// Os títulos de MenuItem vêm de `sidebar-routes.ts` como literais em português
// (porta 1:1 do Angular). Este mapa faz a ponte para as chaves i18n em
// `sidebar.*`; títulos repetidos entre nós distintos (ex.: "Relatórios",
// "Configurações", "Câmeras") apontam para a mesma chave — o Angular original
// também exibe o mesmo texto literal nesses nós, então a colisão de exibição
// não é um problema. O rótulo dinâmico de LGPD (`context.lgpdLabel`) nunca
// aparece aqui: cai no fallback abaixo por design.
const MENU_TITLE_TO_I18N_KEY: Record<string, string> = {
  Home: 'sidebar.home',
  INICIO: 'sidebar.inicio',
  Integradores: 'sidebar.integradores',
  USUARIOS: 'sidebar.usuarios',
  LGPD: 'sidebar.lgpd',
  Relatórios: 'sidebar.relatorios',
  Contas: 'sidebar.contas',
  Contratos: 'sidebar.contratos',
  SMS: 'sidebar.sms',
  GESTAO_PRE_CADASTROS: 'sidebar.gestaoPreCadastros',
  Configurações: 'sidebar.configuracoes',
  Customização: 'sidebar.customizacao',
  Autenticação: 'sidebar.autenticacao',
  WhatsApp: 'sidebar.whatsapp',
  'Pré-cadastro': 'sidebar.preCadastro',
  'Segware Shield': 'sidebar.segwareShield',
  Suporte: 'sidebar.suporte',
  CAPTURA_TELA: 'sidebar.capturaTela',
  Recados: 'sidebar.recados',
  'Integração PSIM': 'sidebar.integracaoPsim',
  Dispositivos: 'sidebar.dispositivos',
  'Log de Operações': 'sidebar.logOperacoes',
  Webhook: 'sidebar.webhook',
  'Descartes PSIM': 'sidebar.descartesPsim',
  'Versões APPs': 'sidebar.versoesApps',
  'Log de erros': 'sidebar.logErros',
  Auditoria: 'sidebar.auditoria',
  'Primeiro acesso': 'sidebar.primeiroAcesso',
  Chamadas: 'sidebar.chamadas',
  'Termos de uso': 'sidebar.termosUso',
  'Política de privacidade': 'sidebar.politicaPrivacidade',
  Migração: 'sidebar.migracao',
  Unidades: 'sidebar.unidades',
  Pessoas: 'sidebar.pessoas',
  Aluguel: 'sidebar.aluguel',
  'Previsões de visita': 'sidebar.previsoesVisita',
  'Área comum': 'sidebar.areaComum',
  Grupos: 'sidebar.grupos',
  Estacionamentos: 'sidebar.estacionamentos',
  Fornecedor: 'sidebar.fornecedor',
  'Categoria de ocorrência': 'sidebar.categoriaOcorrencia',
  ENTREGA_AUTONOMA: 'sidebar.entregaAutonoma',
  Cadastros: 'sidebar.cadastros',
  Agendamentos: 'sidebar.agendamentos',
  Ocorrências: 'sidebar.ocorrencias',
  Correspondências: 'sidebar.correspondencias',
  Documentos: 'sidebar.documentos',
  'Manutenção (Beta)': 'sidebar.manutencao',
  ZELADOR_IA: 'sidebar.zeladorIa',
  Assembleia: 'sidebar.assembleia',
  ENQUETES: 'sidebar.enquetes',
  Timeline: 'sidebar.timeline',
  Portaria: 'sidebar.portaria',
  Conexões: 'sidebar.conexoes',
  Câmeras: 'sidebar.cameras',
  LPR: 'sidebar.lpr',
  VMS: 'sidebar.vms',
  CFTV: 'sidebar.cftv',
  Conexão: 'sidebar.conexao',
  'Conexão BI': 'sidebar.conexaoBi',
  Eventos: 'sidebar.eventos',
  Key: 'sidebar.key',
  'Chave virtual': 'sidebar.chaveVirtual',
  PSIM: 'sidebar.psim',
  Locker: 'sidebar.locker',
  Conta: 'sidebar.conta',
  Integrações: 'sidebar.integracoes',
  ACIONAMENTOS: 'sidebar.acionamentos',
  Ocorrência: 'sidebar.ocorrencia',
  'Previsão de visita': 'sidebar.previsaoVisita',
  Veiculos: 'sidebar.veiculos',
  Notificações: 'sidebar.notificacoes',
  RELES: 'sidebar.reles',
  Horários: 'sidebar.horarios',
  Perfis: 'sidebar.perfis',
  Credenciais: 'sidebar.credenciais',
  STATUS_DISPOSITIVO: 'sidebar.statusDispositivo',
  "Log's": 'sidebar.logs',
  SINCRONIZACAO: 'sidebar.sincronizacao',
  AUTONOMO_TITULO: 'sidebar.autonomoTitulo',
  CONTROLE_DE_ACESSO: 'sidebar.controleDeAcesso',
  EQUIPAMENTOS: 'sidebar.equipamentos',
  PERFIS_DE_ACESSO: 'sidebar.perfisDeAcesso',
  CONVITE_VIRTUAL: 'sidebar.conviteVirtual',
  'Chave Virtual': 'sidebar.chaveVirtualAcesso',
  VOIP: 'sidebar.voip',
  Troncos: 'sidebar.troncos',
};

/**
 * Traduz o título literal de um MenuItem para o idioma ativo. Títulos sem
 * entrada no mapa (incluindo o rótulo dinâmico de LGPD) são exibidos como
 * vieram — sem tradução — em vez de vazar a chave i18n não resolvida.
 */
export function translateMenuTitle(title: string, t: (key: string) => string): string {
  const key = MENU_TITLE_TO_I18N_KEY[title];
  return key ? t(key) : title;
}
